export default {
  user: null,
  users: [],
  error: false
};
